'use strict';

import React from 'react';
import moment from 'moment';

import { OnSchedRest }  from '../../../OnSchedRest';
import SearchDropdown   from '../../SearchDropdown/SearchDropdown';


const AvailabilityTimezone = ({ element, date, setTimezone, timezoneName, setAvailability, searching, setSearching }) => {
  if (element.options.timezone === false) {
    return null
  }

  const [regions, setRegions] = React.useState([]);
  const [timezones, setTimezones] = React.useState([]);

  React.useEffect(() => {
    OnSchedRest.Get(element.onsched.setupApiBaseUrl + '/companies/timezones/' + moment(date).format('YYYY-MM-DD'), response => {
      setRegions(response.regions);
      setTimezones(response.timezones);
    })
  }, [])

  const options={
    grouped: true,
    groupBy: 'region'
  }

  return (
    <>
      <SearchDropdown 
        name='' 
        label='' 
        options={options} 
        data={timezones} 
        value='timezoneIanna' 
        timezoneName={timezoneName}
        setTimezone={setTimezone}
        element={element} 
        searching={searching} 
        setSearching={setSearching} 
        date={date}
        setAvailability={setAvailability}
      />
    </>
  )
}

export default AvailabilityTimezone;
